import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ChevronRight from "@mui/icons-material/ChevronRight";
import ExpandMore from "@mui/icons-material/ExpandMore";
import Collapse from "@mui/material/Collapse";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent, useEffect } from "react";
import { Box, Button, FlexRowCenter, OverflowText, Text } from "src/designSystem/index";
import AttributesGroup from "./AttributesGroup";
import CustomViewAttributeContainer from "./CustomViewAttributeContainer";
import css from "./CustomViewAttributes.module.css";

interface AttributesContainerProps {
	/** container */
	container: CustomViewAttributeContainer;
}

const AttributesContainer: FunctionComponent<AttributesContainerProps> = observer(function AttributesContainer({ container }) {
	const {
		canShowAdditionalPaths,
		expanded,
		filteredOut,
		groups,
		name,
		onClickAdditionalPaths,
		toggleExpanded,
		uniqueId,
	} = container;

	if (filteredOut) {
		return null;
	}

	return (
		<Box data-csi-attribute-container={uniqueId}>
			<FlexRowCenter
				aria-label={`${expanded ? "collapse" : "expand"} ${name}`}
				className={css.container}
				onClick={toggleExpanded}
			>
				{expanded ?
					<ExpandMore />
					:
					<ChevronRight />
				}
				<OverflowText
					bold
					grow
					lineHeight={20}
					size={14}
					text={name}
					tooltipProps={{ placement: "right" }}
				/>
				{canShowAdditionalPaths && (
					<Button
						design="link"
						endIcon={<ArrowForwardIcon />}
						onClick={onClickAdditionalPaths}
					>
						<Text
							res="CustomViewAttributesAdditionalPaths"
							semiBold
						/>
					</Button>
				)}
			</FlexRowCenter>
			<Collapse in={expanded} timeout={250}>
				{expanded && groups.map((group) => (
					<AttributesGroup
						group={group}
						key={group.id}
					/>
				))}
			</Collapse>
		</Box>
	);
});

export default AttributesContainer;